import service from '@/api/therapyDetails';
import directory from '@/api/adminDirectory';

function toError(e) {
    return {
        status: e?.response?.status || 0,
        message: e?.response?.data?.message || ''
    };
}

export const state = {
    service: service('doctor'),
    directory: directory('admin'),
    detail: null,
    detailLoading: false,
    detailError: null,
    summary: null,
    summaryLoading: false,
    summaryError: null,
    phases: [],
    phasesLoading: false,
    phasesError: null,
    events: [],
    eventsLoading: false,
    eventsError: null,
    transitioning: false
};

export const getters = {
    detail: function (state) {
        return state.detail;
    },
    detailLoading: function (state) {
        return !!state.detailLoading;
    },
    detailError: function (state) {
        return state.detailError;
    },
    summary: function (state) {
        return state.summary;
    },
    summaryLoading: function (state) {
        return !!state.summaryLoading;
    },
    summaryError: function (state) {
        return state.summaryError;
    },
    phases: function (state) {
        return state.phases;
    },
    phasesLoading: function (state) {
        return !!state.phasesLoading;
    },
    phasesError: function (state) {
        return state.phasesError;
    },
    events: function (state) {
        return state.events;
    },
    eventsLoading: function (state) {
        return !!state.eventsLoading;
    },
    eventsError: function (state) {
        return state.eventsError;
    },
    transitioning: function (state) {
        return !!state.transitioning;
    }
};

export const mutations = {
    'SET_DETAIL': function (state, detail = null) {
        state.detail = detail;
    },
    'SET_DETAIL_LOADING': function (state, boolean = true) {
        state.detailLoading = boolean;
    },
    'SET_DETAIL_ERROR': function (state, error = null) {
        state.detailError = error;
    },
    'SET_SUMMARY': function (state, summary = null) {
        state.summary = summary;
    },
    'SET_SUMMARY_LOADING': function (state, boolean = true) {
        state.summaryLoading = boolean;
    },
    'SET_SUMMARY_ERROR': function (state, error = null) {
        state.summaryError = error;
    },
    'SET_PHASES': function (state, phases = []) {
        state.phases = phases;
    },
    'SET_PHASES_LOADING': function (state, boolean = true) {
        state.phasesLoading = boolean;
    },
    'SET_PHASES_ERROR': function (state, error = null) {
        state.phasesError = error;
    },
    'SET_EVENTS': function (state, events = []) {
        state.events = events;
    },
    'SET_EVENTS_LOADING': function (state, boolean = true) {
        state.eventsLoading = boolean;
    },
    'SET_EVENTS_ERROR': function (state, error = null) {
        state.eventsError = error;
    },
    'SET_TRANSITIONING': function (state, boolean = true) {
        state.transitioning = boolean;
    }
};

export const actions = {
    detail: function ({commit, state}, {id, params}) {
        commit('SET_DETAIL_LOADING', true);
        commit('SET_DETAIL_ERROR', null);

        return state.service.fetchComplianceDetails(id, params).then(response => {
            commit('SET_DETAIL', response?.data || null);
            commit('SET_DETAIL_LOADING', false);

            return response?.data || null;
        }).catch(e => {
            commit('SET_DETAIL_ERROR', toError(e));
            commit('SET_DETAIL_LOADING', false);

            return null;
        });
    },

    summary: function ({commit, state}, id) {
        commit('SET_SUMMARY_LOADING', true);
        commit('SET_SUMMARY_ERROR', null);

        return state.service.fetchCompliance(id).then(response => {
            commit('SET_SUMMARY', response || null);
            commit('SET_SUMMARY_LOADING', false);

            return response;
        }).catch(e => {
            commit('SET_SUMMARY_ERROR', toError(e));
            commit('SET_SUMMARY_LOADING', false);

            return null;
        });
    },

    phases: function ({commit, state}, id) {
        commit('SET_PHASES_LOADING', true);
        commit('SET_PHASES_ERROR', null);

        return state.service.fetchPhases(id).then(response => {
            commit('SET_PHASES', response?.data || []);
            commit('SET_PHASES_LOADING', false);

            return response?.data || [];
        }).catch(e => {
            commit('SET_PHASES_ERROR', toError(e));
            commit('SET_PHASES_LOADING', false);

            return [];
        });
    },

    events: function ({commit, state}, id) {
        commit('SET_EVENTS_LOADING', true);
        commit('SET_EVENTS_ERROR', null);

        return state.directory.fetchAuditEvents({entity_id: id, per_page: 50}).then(response => {
            commit('SET_EVENTS', response?.data || []);
            commit('SET_EVENTS_LOADING', false);

            return response?.data || [];
        }).catch(e => {
            commit('SET_EVENTS_ERROR', toError(e));
            commit('SET_EVENTS_LOADING', false);

            return [];
        });
    },

    transition: function ({commit, state}, {id, action, data}) {
        commit('SET_TRANSITIONING', true);

        return state.service.transition(id, action, data).then(response => {
            commit('SET_TRANSITIONING', false);

            return response?.data || response;
        }).catch(e => {
            commit('SET_TRANSITIONING', false);

            throw e;
        });
    },

    clear: function ({commit}) {
        commit('SET_DETAIL', null);
        commit('SET_DETAIL_ERROR', null);
        commit('SET_SUMMARY', null);
        commit('SET_SUMMARY_ERROR', null);
        commit('SET_PHASES', []);
        commit('SET_PHASES_ERROR', null);
        commit('SET_EVENTS', []);
        commit('SET_EVENTS_ERROR', null);
    }
};
